module.exports = __webpack_public_path__ + "img/safari-31e5becdfaa82e61a2c304ae2802c5d7.svg";